import Vue from 'vue';
import store from 'store';
import _ from 'lodash';

$(() => {

	let app = new Vue({
		el: 'body',
		data: {
			my_id: $('#product_id').val(),
			favorites: store.get('favorites') || [],
			checked: false
		},
		methods: {
			is_favorite: function() {
				return _.indexOf(this.favorites, this.my_id) >= 0;
			}
		},
		watch: {
			'checked': function() {
				if (this.checked) {
					// 登録
					if (_.indexOf(this.favorites, this.my_id) < 0) {
						this.favorites.push(this.my_id);
					}
				}
				else {
					// 削除
					let idx = _.indexOf(this.favorites, this.my_id);
					this.favorites.splice(idx, 1);
				}
			},
			'favorites': function() {
				$(window).trigger('ON_UPDATE_FAVORITE', [this.favorites.length]);
				store.set('favorites', this.favorites);
			}
		}
	});
	app.checked = app.is_favorite();
});




// WEBPACK FOOTER //
// ./scripts/product_detail.js